import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stepNo: 0,
};

const customizationSlice = createSlice({
  name: 'customization',
  initialState,
  reducers: {
    saveStepNo(state, action) {
      state.stepNo = action.payload;
    },
  },
});

export const { saveStepNo } = customizationSlice.actions;

export default customizationSlice.reducer;
